import React from 'react'
import { useNavigate } from 'react-router'

const OurLink = ({ to, children, className: style, clickable = true }) => {
  const navigate = useNavigate()
  return (
    <a onClick={!clickable ? () => { } : () => navigate(to)} className={`text-decoration-none cursor-pointer ${style || ''} ${clickable ? '' : 'cursor-normal'}`}>
      {children}
    </a>
  )
}

export default OurLink
